import React from 'react';

import { v4 as uuid } from 'uuid';
import HelpTooltip from '../SteppedForm/HelpTooltip';

import { Button, Grid, Typography, FormControlLabel } from '@material-ui/core';
import { Close as CloseIcon, Help as HelpIcon } from '@material-ui/icons';

import { TextField, Step } from '../SteppedForm';

import rules from './rules';

const StepRelatedorgs = (props) => {
  return (
    <Step
      id="relatedorgs"
      title="Related Entities"
      skip={(formdata) =>
        formdata?.orgtype === 'individual' ||
        !props.stateconfig().relatedentities ||
        formdata.onboardingFor === 'vehicle'
      }>
      <HelpTooltip title="Any Parent, Subsidiary and any business, corporation, partnership, limited liability company or other entity in which the Company, partnership, a Parent or a Subsidiary holds a substantial ownership interest, directly or indirectly.">
        <FormControlLabel
          control={<HelpIcon style={{ marginLeft: '10px', color: '#1a76d9' }}></HelpIcon>}
          labelPlacement="start"
          label={
            <Typography variant="body1" class="formQuestion">
              Is the {props.state?.formdata?.orgtype} related to any other entities?
            </Typography>
          }
        />
      </HelpTooltip>
      <br />

      <Grid container>
        {props.state?.formdata?.relent
          ? props.state?.formdata?.relent.map((relent, i) => (
              <React.Fragment key={relent.id + '-' + i}>
                <Grid item xs={5}>
                  <TextField
                    id={'relname-' + i}
                    label="Name"
                    value={relent.name}
                    required
                    valid={{
                      valid: (v) => {
                        try {
                          return v.relent[i].name;
                        } catch (e) {
                          return false;
                        }
                      },
                      message: 'is a required field'
                    }}
                    onChange={(e) =>
                      props.setState({
                        formdata: {
                          ...props.state.formdata,
                          relent: props.state?.formdata?.relent.map((v, idx) =>
                            idx === i ? { ...v, name: e.target.value } : v
                          )
                        }
                      })
                    }
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    id={'relacn-' + i}
                    label="ACN (Without Spaces)"
                    value={relent.acn}
                    modify={(value) => props.limitLength(value, 9)}
                    required
                    valid={{
                      valid: (v) => {
                        try {
                          return rules.acn.valid(v.relent[i].acn);
                        } catch (e) {
                          return false;
                        }
                      },
                      message: rules.acn.message
                    }}
                    onChange={(e) =>
                      props.setState({
                        formdata: {
                          ...props.state?.formdata,
                          relent: props.state.formdata.relent.map((v, idx) =>
                            idx === i ? { ...v, acn: e.target.value } : v
                          )
                        }
                      })
                    }
                  />
                </Grid>
                <Grid item xs={1}>
                  <CloseIcon
                    className="remove"
                    onClick={() => {
                      props.setState(
                        {
                          formdata: {
                            ...props.state?.formdata,
                            relent: props.state?.formdata?.relent.filter((o, idx) => idx !== i)
                          }
                        },
                        async () => await props.persist()
                      );
                    }}
                  />
                </Grid>
              </React.Fragment>
            ))
          : ''}
      </Grid>
      <Button
        variant="contained"
        onClick={() =>
          props.setState({
            formdata: {
              ...props.state.formdata,
              relent: props.state?.formdata?.relent
                ? [...props.state?.formdata?.relent, { id: uuid() }]
                : [{ id: uuid() }]
            }
          })
        }>
        Add Related Entity
      </Button>
    </Step>
  );
};

export default StepRelatedorgs;
